export const calculateMaxPoint = (points: number[]): number => {
  return Math.max(...points);
};
